// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2ARMWpQ_h9ZmV3NVBgC2CQ","buttonContainer":"_2raIXwO66RawWafO-1cWDR","extraAction":"tDFyR9HaTgBe0TDnqXosg"};